import * as i0 from '@angular/core';
import { signal, output, viewChild, effect, Component, Optional, Self } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormControl, FormArray, ReactiveFormsModule } from '@angular/forms';
const _c0 = ["inputEl"];
function OtpInputComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 3);
    i0.ɵɵlistener("blur", function OtpInputComponent_For_3_Template_input_blur_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTouch());
    })("focus", function OtpInputComponent_For_3_Template_input_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.placeholderSet($event.target, false));
    })("focusout", function OtpInputComponent_For_3_Template_input_focusout_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.placeholderSet($event.target, true));
    })("paste", function OtpInputComponent_For_3_Template_input_paste_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handlePaste($event));
    })("keydown", function OtpInputComponent_For_3_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleChange($event));
    })("keyup", function OtpInputComponent_For_3_Template_input_keyup_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleChange());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const input_r3 = ctx.$implicit;
    const $index_r4 = ctx.$index;
    i0.ɵɵproperty("maxLength", 1)("name", $index_r4)("formControl", input_r3);
  }
}
let OtpInputComponent = /*#__PURE__*/(() => {
  class OtpInputComponent {
    constructor(ngControl) {
      this.ngControl = ngControl;
      this.OTP_LENGTH = 6;
      this.inputs = this.getFormArray(this.OTP_LENGTH);
      this.disabled = signal(false);
      this.otpChange = output();
      this.inputEls = viewChild('inputEl');
      this.onChange = () => {};
      this.onTouch = () => {};
      if (this.ngControl != null) {
        this.ngControl.valueAccessor = this;
      }
      effect(() => {
        const disable = this.disabled();
        this.inputs.controls.forEach(control => {
          if (disable) {
            control.disable({
              emitEvent: false
            });
          } else {
            control.enable({
              emitEvent: false
            });
          }
        });
        if (disable) {
          this.inputs.disable({
            emitEvent: true
          });
        } else {
          this.inputs.enable({
            emitEvent: true
          });
        }
      });
    }
    writeValue(otp) {
      this.writeStringIntoInputs(otp);
      this.otpChange.emit(otp);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled.set(isDisabled);
    }
    getFormArray(size) {
      const arr = [];
      for (let i = 0; i < size; i++) {
        arr.push(new FormControl(undefined));
      }
      return new FormArray(arr);
    }
    placeholderSet(target, show) {
      const element = target;
      element.placeholder = show ? 'X' : '';
    }
    handleChange(event) {
      const otpInputs = this.inputs.getRawValue();
      if (event && event.key == 'Enter') {
        this.otpInputsChange();
        return;
      }
      for (const [idx, otp] of otpInputs.entries()) {
        const value = typeof otp === 'string' ? +otp.trim() : otp;
        if (isNaN(value)) {
          this.inputs.at(idx).setValue(undefined);
        }
        if (value != null && `${value}`.length > 1) {
          this.inputs.at(idx).setValue(`${value}`.at(0));
        }
        const newOtp = this.inputs.at(idx).value;
        if (newOtp == null) {
          (this.inputEls()?.nativeElement.children.namedItem(idx.toString())).focus();
          break;
        }
      }
      if (event && event.key == 'Backspace') {
        const eventTarget = event.target;
        const idx = +eventTarget.name;
        const previousInputIdx = Math.max(idx - 1, 0);
        let value = eventTarget.value;
        const otpInput = value == null || value == '' ? this.inputEls()?.nativeElement.children.namedItem(previousInputIdx.toString()) : this.inputEls()?.nativeElement.children.namedItem(eventTarget.name);
        const otpInputIdx = value == null ? previousInputIdx : idx;
        this.inputs.at(otpInputIdx)?.setValue(null);
        otpInput?.focus();
      }
      this.otpInputsChange();
    }
    handlePaste(event) {
      event.preventDefault();
      const clipboardData = event.clipboardData || window['clipboardData'];
      const pastedData = clipboardData.getData('text');
      this.writeStringIntoInputs(pastedData);
      this.otpInputsChange();
    }
    otpToString() {
      return this.inputs.getRawValue().filter(v => !isNaN(v)).join('');
    }
    writeStringIntoInputs(otp) {
      if (!otp) {
        return;
      }
      if (otp.split('').some(e => isNaN(+e))) return;
      for (let i = 0; i < otp.length; i++) {
        this.inputs.at(i).setValue(otp[i]);
      }
      (this.inputEls()?.nativeElement.children.namedItem((this.OTP_LENGTH - 1).toString())).focus();
    }
    otpInputsChange() {
      const otpString = this.otpToString();
      if (this.oldOtp === otpString) {
        return;
      }
      this.oldOtp = otpString;
      this.onChange(otpString);
      this.otpChange.emit(otpString);
    }
    static {
      this.ɵfac = function OtpInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OtpInputComponent)(i0.ɵɵdirectiveInject(i1.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OtpInputComponent,
        selectors: [["fut-otp-input"]],
        viewQuery: function OtpInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.inputEls, _c0, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        outputs: {
          otpChange: "otpChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 0,
        consts: [["inputEl", ""], [1, "otp-container", "fut-gap-8"], ["type", "number", "inputmode", "numeric", "maxlength", "1", "min", "0", "max", "9", "placeholder", "X", 3, "maxLength", "name", "formControl"], ["type", "number", "inputmode", "numeric", "maxlength", "1", "min", "0", "max", "9", "placeholder", "X", 3, "blur", "focus", "focusout", "paste", "keydown", "keyup", "maxLength", "name", "formControl"]],
        template: function OtpInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵrepeaterCreate(2, OtpInputComponent_For_3_Template, 1, 3, "input", 2, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.inputs.controls);
          }
        },
        dependencies: [ReactiveFormsModule, i1.DefaultValueAccessor, i1.NumberValueAccessor, i1.NgControlStatus, i1.MaxLengthValidator, i1.MinValidator, i1.MaxValidator, i1.FormControlDirective],
        styles: [".otp-container[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;margin-top:2em;margin-bottom:2em}.otp-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{height:2.5em;width:1.5em;font-size:1.5em;text-align:center;border-radius:.5em;border:1px solid rgba(33,37,41,.6)}.otp-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{border-color:var(--fut-secondary-800);outline:1px solid var(--fut-secondary-800)!important}@media screen and (max-width: 767px){.otp-container[_ngcontent-%COMP%], .otp-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%}}input[_ngcontent-%COMP%]::-webkit-outer-spin-button, input[_ngcontent-%COMP%]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}input[type=number][_ngcontent-%COMP%]{-moz-appearance:textfield}"]
      });
    }
  }
  return OtpInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { OtpInputComponent };
